import useJwt from '@/auth/jwt/useJwt';

const cost = `${process.env.VUE_APP_URL}/api/v1/cost/`;

export default {
  namespaced: true,
  state: {
    //List management
    list: [],
    totalRecords: null,
    nextUrl: null,
    previousUrl: null,
    currentUrl: null,
    //Create/Edit Financial Account and value
    selectedFinancialAccountData: {},
    financialAccountValue: null,
    orderField: '',
    orderDict: {
      ID: "number",
      name: "name",
      expense_group: "expense_group",
    },
    finAccountsTotal: 0, // Total amount of financial accounts
  },
  mutations: {
    SET_FINANCIAL_ACCOUNTS_TOTAL(state, data) {
      state.finAccountsTotal = data;
    },
    SET_FACCOUNTS(state, fa) {
      state.list = fa
    },
    SET_NEXT_URL(state, url) {
      state.nextUrl = url
    },
    SET_PREVIOUS_URL(state, url) {
      state.previousUrl = url
    },
    SET_CURRENT_URL(state, url) {
      state.currentUrl = url
    },
    SET_TOTAL_RECORDS(state, records) {
      state.totalRecords = records
    },
    // FINANCIAL ACCOUNT DATA
    SET_SELECTED_FINANCIAL_ACCOUNT_DATA(state, data) {
      state.selectedFinancialAccountData = data
    },
    SET_FINANCIAL_ACCOUNT_ID(state, id) {
      let newFAData = { ...state.selectedFinancialAccountData };
      newFAData.ID = id;
      state.selectedFinancialAccountData = newFAData;
    },
    SET_FINANCIAL_ACCOUNT_NAME(state, name) {
      let newFAData = { ...state.selectedFinancialAccountData };
      newFAData.name = name;
      state.selectedFinancialAccountData = newFAData;
    },
    SET_FINANCIAL_ACCOUNT_EXPENSE_GROUP(state, expense_group) {
      let newFAData = { ...state.selectedFinancialAccountData };
      newFAData.expense_group = expense_group;
      state.selectedFinancialAccountData = newFAData;
    },
    CLEAR_SELECTED_FINANCIAL_ACCOUNT(state) {
      state.selectedFinancialAccountData = {}
    },
    SET_FINANCIAL_ACCOUNT_VALUE(state, value) {
      state.financialAccountValue = value
    },
    CLEAR_FINANCIAL_ACCOUNT_VALUE(state) {
      state.financialAccountValue = null
    },
    SET_ORDER_FIELD(state, data) {
      switch (data.orderType) {
        case 'asc':
          state.orderField = state.orderDict[data.orderField];
          break;
        case 'desc':
          state.orderField = `-${state.orderDict[data.orderField]}`;
          break;
        default:
          state.orderField = null;
          break;
      }
    }
  },
  actions: {
    getFinAccountsTotal({ commit }, { context, scenarioId }) {
      return context.$http.get(`${cost}financial-accounts/get-amount-sum/?scenario=${scenarioId}`)
        .then(response => {
          commit('SET_FINANCIAL_ACCOUNTS_TOTAL', response.data.total);
          return true;
        });
    },
    getFinancialAccounts({ commit, state }, { context, scenarioId, limit, offset }) {
      let order = state.orderField ? `&ordering=${state.orderField}` : ''
      let getOffset = offset ? `&offset=${offset}` : ''
      let getUrl = state.currentUrl || `${cost}financial-accounts/get-table/?limit=${limit}&scenario=${scenarioId}${order}${getOffset}`;
      context.$http.get(
        getUrl)
        .then(response => {
          commit('SET_FACCOUNTS', response.data.results ? response.data.results : response.data);
          commit('SET_NEXT_URL', response.data.next);
          commit('SET_PREVIOUS_URL', response.data.previous);
          commit('SET_TOTAL_RECORDS', response.data.count);
        });
    },
    getFinancialAccountsTemplateFile({ commit }, { context, modelId }) {
      try {
        context.$http.get(
          `${cost}financial-accounts/get-template-file/?model=${modelId}`,
          {
            headers: {
              'Content-Type': 'application/octet-stream'
            },
            responseType: 'blob'
          }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", `financial_accounts_template_file_${modelId}.csv`);
            document.body.appendChild(fileLink);

            fileLink.click();
          });
      } catch (err) {
        console.log(err.response);
      }
    },
    getFinancialAccountsDataFile({ commit }, { context, modelId, scenarioId }) {
      try {
        context.$http.get(
          `${cost}financial-accounts/get-data-file/?model=${modelId}&scenario=${scenarioId}`,
          {
            headers: {
              'Content-Type': 'application/octet-stream'
            },
            responseType: 'blob'
          }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", `financial_accounts_data_file_${modelId}_${scenarioId}.csv`);
            document.body.appendChild(fileLink);

            fileLink.click();
          });
      } catch (err) {
        console.log(err.response);
      }
    },
    deleteFinancialAccount({ commit, state }, { context, id }) {
      // DELETE financial account
      let getUrl = state.currentUrl || `${cost}financial-accounts/${id}/`;
      return context.$http.delete(getUrl);
    },
    setNextUrlAsCurrent({ commit, state }) {
      commit('SET_CURRENT_URL', state.nextUrl);
    },
    setPreviousUrlAsCurrent({ commit, state }) {
      commit('SET_CURRENT_URL', state.PreviousUrl);
    },
    clearCurrentEndpoint({ commit }) {
      commit('SET_CURRENT_URL', null);
    },
    clearFinancialAccounts({ commit }) {
      commit('SET_FACCOUNTS', []);
    },
    //Manage Selected Financial Account Data
    setSelectedFinancialAccountData({ commit }, data) {
      commit('SET_SELECTED_FINANCIAL_ACCOUNT_DATA', data);
    },
    setFinancialAccountId({ commit }, id) {
      commit('SET_FINANCIAL_ACCOUNT_ID', id);
    },
    setFinancialAccountName({ commit }, name) {
      commit('SET_FINANCIAL_ACCOUNT_NAME', name);
    },
    setFinancialAccountExpenseGroup({ commit }, expense_group) {
      commit('SET_FINANCIAL_ACCOUNT_EXPENSE_GROUP', expense_group);
    },
    clearSelectedFinancialAccount({ commit }) {
      commit('CLEAR_SELECTED_FINANCIAL_ACCOUNT');
    },
    createFinancialAccount({ commit, state }, { context, modelId }) {
      let getUrl = `${cost}financial-accounts/`;
      return context.$http.post(
        getUrl,
        {
          model: modelId,
          ID: state.selectedFinancialAccountData.ID,
          name: state.selectedFinancialAccountData.name,
          expense_group: state.selectedFinancialAccountData.expense_group
        }).then(res => {
          commit('SET_SELECTED_FINANCIAL_ACCOUNT_DATA', res.data)
          return res;
        });
    },
    updateFinancialAccount({ commit, state }, { context, modelId }) {
      let getUrl = `${cost}financial-accounts/${state.selectedFinancialAccountData.account_id}/`;
      return context.$http.put(
        getUrl,
        {
          model: modelId,
          ID: state.selectedFinancialAccountData.ID,
          name: state.selectedFinancialAccountData.name,
          expense_group: state.selectedFinancialAccountData.expense_group
        }).then(res => {
          commit('SET_SELECTED_FINANCIAL_ACCOUNT_DATA', res.data)
          return res;
        });
    },

    //Manage Finacial Account Value
    setFinancialAccountValue({ commit }, data) {
      commit('SET_FINANCIAL_ACCOUNT_VALUE', data);
    },
    clearFinancialAccountValue({ commit }) {
      commit('CLEAR_FINANCIAL_ACCOUNT_VALUE');
    },
    clearModalData({ commit }) {
      commit('CLEAR_SELECTED_FINANCIAL_ACCOUNT');
      commit('CLEAR_FINANCIAL_ACCOUNT_VALUE');
    },
    createFinancialAccountValue({ state }, { context, scenarioId }) {
      let postUrl = `${cost}account-values/`;
      return context.$http.post(
        postUrl,
        {
          scenario: scenarioId,
          account: state.selectedFinancialAccountData.account_id,
          amount: state.financialAccountValue
        });
    },
    updateFinancialAccountValue({ state, dispatch }, { context, scenarioId }) {
      // GET Account Value Id
      let getUrl = `${cost}account-values/?scenario=${scenarioId}&account=${state.selectedFinancialAccountData.account_id}`;
      return context.$http.get(getUrl)
        .then((res) => {
          console.log("RES AFTER GET", res)
          if (res.data.length == 0) {
            //create
            return dispatch("createFinancialAccountValue", { context: context, scenarioId: scenarioId })
          } else {
            let putUrl = `${cost}account-values/${res.data[0].id}/`
            return context.$http.patch(
              putUrl,
              {
                amount: state.financialAccountValue
              });
          }
        })
        // UPDATE
        .catch(err => {
          // IF NOT...CREATE
          console.log("ERR2", err.response);
          if (err.response.status == 400) {
            return dispatch("createFinancialAccountValue", { context: context, scenarioId: scenarioId });
          }
          throw err;
        });
    }

  },
}
